import { useState } from 'react';

export type FormBuilderKeyValueMap = Record<string, string>;

export interface FormBuilderDefaultFieldValue {
  key: string;
  value: unknown;
  includeInSubmitRequest: boolean;
}

export const useFormBuilderState = (defaultFieldValues: FormBuilderDefaultFieldValue[] = []) => {
  const [keyValues, setKeyValues] = useState<FormBuilderKeyValueMap>(() =>
    defaultFieldValues.reduce((acc, curr) => ({ ...acc, [curr.key]: curr.value }), {})
  );
  const [keysIncludedInSubmitRequest, setKeysIncludedInSubmitRequest] = useState<string[]>(() =>
    defaultFieldValues
      .filter(({ includeInSubmitRequest }) => includeInSubmitRequest)
      .map(({ key }) => key)
  );

  const convertStringToBoolean = (value: string): boolean | string => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
  };

  const setKeyValue = (key: string, value: string) =>
    setKeyValues((prevState) => ({ ...prevState, [key]: value }));

  const includeKeyInSubmitRequest = (key: string) =>
    setKeysIncludedInSubmitRequest((prevState) => [...new Set([...prevState, key])]);

  const getFinalRequestData = () => {
    return keysIncludedInSubmitRequest.reduce(
      (acc, key) => ({ ...acc, [key]: convertStringToBoolean(keyValues[key]) }),
      {}
    );
  };

  return {
    keyValues,
    setKeyValues,
    keysIncludedInSubmitRequest,
    setKeysIncludedInSubmitRequest,
    setKeyValue,
    includeKeyInSubmitRequest,
    getFinalRequestData,
  };
};
